import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=0f71547c&scoped=true&"
import script from "./Shadow.vue?vue&type=script&lang=js&"
export * from "./Shadow.vue?vue&type=script&lang=js&"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=0f71547c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71547c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VTextField})
